import styled from 'styled-components';

const ComponentTitle = styled.span`
  font-size: 20px;
  color: ${props => props.theme.colors.XXD};
`;

export default styled(ComponentTitle)``;
